import { useRef } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import StatWidgetTooltip from './StatWidgetTooltip';

const StatWidgetBox = ({
  icon,
  value,
  loading = false,
  skeletonWidth = 36,
  onClick,
  sx = {},
  tooltipContent = null
}) => {
  const theme = useTheme();
  const anchorRef = useRef(null);
  return (
    <>
      <Box
        ref={anchorRef}
        onClick={onClick}
        // onMouseEnter={handleOpen}
        // onMouseLeave={handleClose}
        sx={{ 
          display: 'flex', 
          height: '100%',
          transition: 'background-color 0.3s ease',
          cursor: 'pointer',
          borderLeft: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            backgroundColor: theme.palette.sidebar.itemHover,
          },
          '&:last-child': {
            borderRight: '1px solid',
            borderColor: 'divider',
          },
        }}
      >
    
        <Box
          onClick={onClick}
          sx={{
            // backgroundColor,
            color: 'text.primary',
            height: '100%',
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: { xs: 1.5, sm: 2 },
            gap: 1,
            transition: 'filter 0.15s ease',
            '&:hover': {
              filter: 'brightness(0.94)'
            },
            ...sx
          }}
        >
          <Box
            sx={{
              border:"1px solid",
              borderColor: 'divider',
              borderRadius: "25%",
              width: { xs: '24px', lg: '28px' },
              height: { xs: '24px', lg: '28px' },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: 'text.secondary',
              
            }}
          >
            {icon}  
          </Box>
          {loading ? (
            <Skeleton 
              variant="text" 
              width={skeletonWidth} 
              height={18} 
            />
          ) : (
            <Typography
              variant="body2"
              noWrap
              sx={{
                fontWeight: 500,
                fontSize: { xs: '12px', lg: '14px' }
              }}>
              {value != null ? `${value}` : '-'}
            </Typography>
          )}
        </Box>
      </Box>
      {
        tooltipContent && 
          <StatWidgetTooltip 
            open={true} 
            anchorEl={anchorRef.current} 
            interactive={true}
          >
            {tooltipContent}
          </StatWidgetTooltip>
      }
    </>
  );
};


export default StatWidgetBox;
